<template>
    <div>
        <el-form ref="ruleForm" :rules="rules" :model="form" label-width="100px">
            <el-form-item label="博主头像:">
                <el-upload class="avatar-uploader" action="api/userinfo/upphoto" :show-file-list="false"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="form.photo" :src="form.photo" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="博主名称:" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="个性签名:">
                <el-input v-model="form.description" type="textarea" :autosize="{ minRows: 2, maxRows: 5}" show-word-limit maxlength="255"></el-input>
            </el-form-item>
            <el-form-item label="GitHub:">
                <el-input v-model="form.GitHub"></el-input>
            </el-form-item>
            <el-form-item label="QQ:">
                <el-input v-model="form.QQ"></el-input>
            </el-form-item>
            <el-form-item label="Wechat:">
                <el-input v-model="form.Wechat"></el-input>
            </el-form-item>
            <el-form-item label="Emaill:">
                <el-input v-model="form.Emaill"></el-input>
            </el-form-item>
            <el-form-item label="Gitee:">
                <el-input v-model="form.Gitee"></el-input>
            </el-form-item>
            <el-form-item label="哔哩哔哩:">
                <el-input v-model="form.bilibili"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="onEdit('ruleForm')">修改</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imageUrl: "",
            form: {
                photo:'',
                name: '',
                description: '',
                GitHub: '',
                QQ: '',
                Wechat: '',
                Emaill: '',
                Gitee: '',
                bilibili: ''
            },
            rules: {
                name: [
                    { required: true, message: '名称不能为空', trigger: 'blur' },
                    { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        handleAvatarSuccess(res, file) {
            console.log(res);
            if(res.meta.status!==200) return this.$message.error(res.meta.msg);
            // this.form.photo = URL.createObjectURL(file.raw);
          this.form.photo = res.data;
          this.$message.success(res.meta.msg);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg'|| file.type === 'image/png';
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG或者PNG 格式!");
            }
            if (!isLt5M) {
                this.$message.error("上传头像图片大小不能超过 5MB!");
            }
            return isJPG  && isLt5M;
        },
        async getUserinfo() {
            const { data: res } = await this.$axios.post('/userinfo');
            this.form = res.data;
            console.log(res);
        },
        onEdit(formName) {
            this.$refs[formName].validate(async valid => {
                if(!valid) return this.$message.error('修改失败');
                const { data: res } = await this.$axios.post('/userinfo/edituser', this.form);
                if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
                this.$message.success(res.meta.msg)
                console.log(res);
            })
        }
    },
    created() {
        this.getUserinfo();
    },
    mounted(){

    }
};
</script>

<style lang="less">
.avatar-uploader .el-upload {
    border: 1px dashed #666;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff !important;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-input,
.el-textarea {
    max-width: 800px;
}
</style>




// WEBPACK FOOTER //
// src/components/userinfo/Userinfo.vue